import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import isLoggedIn, {isAdmin} from '../../../utils/auth';

import * as headerActionCreators from '../../../actions/header';
import * as transfersActionCreators from '../../../actions/transfers';
let allActionCreators = Object.assign({}, headerActionCreators, transfersActionCreators);

import {HeaderMenuContainer} from './HeaderMenu';


class Header extends React.Component {
  
  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      heartbeat: Date.now(),
    };

    // Bind event listener method
    this.beatHeart = ::this.beatHeart;
  }

  componentDidMount() {
    let intId = setInterval(this.beatHeart, 120000);
  }

  beatHeart() {
    this.setState({
      heartbeat: Date.now(),
    }, () => {
      this.fetchPushData();
    });
  }

  fetchPushData() {
    if(isLoggedIn()) {
  
      // Get current page
      let isOpenPage = window.location.pathname.includes('transfers');
      let isPendingPage = window.location.pathname.includes('pending');
      let isClosedPage = window.location.pathname.includes('closed');

      if(isOpenPage) {
        this.props.transfersOpenFetch()
        .then((respData) => {
          this.props.transfersOpenSetList(respData.transfers);
        })
        .catch((errorResp) => {
          console.error(errorResp);
        });
      }

      if(isPendingPage) {
        this.props.transfersIncomingFetch()
        .then((respData) => {
          this.props.transfersPendingSetList(respData.transfers);
        })
        .catch((errorResp) => {
          console.error(errorResp);
        });
      }

      if(isClosedPage) {
        this.props.transfersClosedFetch(this.props.transfers.closedPage)
        .then((respData) => {
          this.props.transfersClosedSetList(respData.transfers);
        })
        .catch((errorResp) => {
          console.error(errorResp);
        });

        this.props.transfersClosedFetch(this.props.transfers.closedPage, true)
        .then((respData) => {
          this.props.transfersClosedSetLgdList(respData.transfers);
        })
        .catch((errorResp) => {
          console.error(errorResp);
        });
      }

      // Fetch transfer counts
      this.props.transfersCountFetch()
      .then((respData) => {
        this.props.transfersSetCounts(respData);
      })
      .catch((errorResp) => {
        console.error(errorResp);
      });

      // Fetch LGD transfer counts
      this.props.transfersCountFetch(true)
      .then((respData) => {
        this.props.transfersSetLgdCounts(respData);
      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    }
  }

  dashboardNav() {
    this.context.router.push('/');
  }

  render() {
    return <div className='Header'>
      {this.props.header.pageBack ? 
        <div className='headerBack' onClick={::this.dashboardNav}>&lt; Back to Videos</div> :
        null
      }
      <div className='headerIcon' onClick={::this.dashboardNav}>
        <div className='iconWrapper'>
          <img src='/img/DDicon_white.svg' />
        </div>
      </div>
      <div className='headerRightMenu'><HeaderMenuContainer /></div>
    </div>
  }
}
export default Header;

function mapStateToProps(state) {
  return {
    header: state.header,
    transfers: state.transfers,
  };
}

export const HeaderContainer = connect(
  mapStateToProps,
  allActionCreators
)(Header);